// extracted by mini-css-extract-plugin
export default {"crop":"crop_crop__jdSkP","crop_ReactCrop":"crop_crop_ReactCrop__qT2Dv"};